const MAX_ZOOM = 13;

class ProductsMap {
  constructor(container) {
    this.container = container;
    this.items = JSON.parse(this.container.getAttribute("data-items"));
    this.setup();

    this.windowOnResizeHandler = () => {
      let isSmDevice = !st.Media.isMin("md");
      return this.gmap.setOptions({
        draggable: !isSmDevice
      });
    };
    this.windowOnResizeHandler();
    $(window).on("resize", this.windowOnResizeHandler);
  }

  setup() {
    this.gmap = new google.maps.Map(this.container, {
      center: {lat: 52.2297700, lng: 21.0117800}, // Warsaw's coordinates
      zoom: 8,
      scrollwheel: false,
      mapTypeControl: false,
      streetViewControl: false
    }
    );

    let markerInfoWindow = null;

    let bounds = new google.maps.LatLngBounds();
    this.markers = _.map(this.items, item => {
      let marker = new google.maps.Marker({
        position: {lat: item.v1_location_lat, lng: item.v1_location_lng},
        map: this.gmap,
        title: item.name
      });
      bounds.extend(marker.getPosition());

      let onClick = () => {
        if (markerInfoWindow) {
          markerInfoWindow.close();
        }

        markerInfoWindow = new google.maps.InfoWindow({
          content: `\
<div class="gmaps-info-window gmaps-item-info-window">
  <a href="${item.url}"><img class="item-image" src="${item.main_image_file.tile.url}" /></a>
  <div class="item-content">
    <a href="${item.url}" class="item-name">${item.name}</a>
    <p class="item-description">${item.short_description}</p>
    ${(item.featured_order ? `<div class='item-price'> \
${I18n.t("base.from")} <span class='price-value'>${st.formatMoney( st.exchangeMoney(item.featured_order.price, st.currency || item.featured_order.price.currency) )}</span>! \
</div>` : undefined) || ""}
    <div class="item-cta">
      <a href="${item.url}" class="btn btn-primary">${I18n.t("fe.products_map.buy_product")}</a>
    </div>
  </div>
</div>\
`
        });
        return markerInfoWindow.open(this.gmap, marker);
      };
      marker.addListener("click", onClick);

      return marker;
    }
    );

    this.gmap.fitBounds(bounds);
    return google.maps.event.addListenerOnce(this.gmap, "idle", () => {
      if (this.gmap.getZoom() > MAX_ZOOM) { return this.gmap.setZoom(MAX_ZOOM); }
    }
    );
  }

  destroy() {
    return $(window).off("resize", this.windowOnResizeHandler);
  }
}

onGoogleLoad(() => {
  $(".products-map").each(function() {
    return window.productsMap = new ProductsMap(this);
  })
})



// WEBPACK FOOTER //
// ./app/webpack/frontend/initializers/products_map.js